import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type {
  TypePostShippingLabelsCancelParams,
  TypePostShippingLabelsCancelResponse,
} from '~/types/delivery-agency.types';

/**
 * [운송장 관리] 운송장 취소 API
 */
const fetchPostShippingLabelsCancel = async (
  params: TypePostShippingLabelsCancelParams
): Promise<TypePostShippingLabelsCancelResponse['data']> => {
  const { data } = await axiosInstance.post<TypePostShippingLabelsCancelResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.POST_SHIPPING_LABELS_CANCEL,
    params
  );
  return data.data;
};

/**
 * [운송장 관리] 운송장 취소 Mutation Hook
 */
export const usePostShippingLabelsCancelMutation = () => {
  return useMutation<
    TypePostShippingLabelsCancelResponse['data'],
    TypeErrorResponseData['error'],
    TypePostShippingLabelsCancelParams
  >({
    mutationFn: fetchPostShippingLabelsCancel,
    meta: { showGlobalErrorToast: false },
  });
};
